/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

// Identity (Idiot)
// identity :: a -> a
var identity =
  function (x) { return x; }

module.exports = identity
